import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Survey, SurveyInterface } from 'app/assessment/survey/models';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { EntityConnectorInterface } from 'app/core/connector-services/entity-connector-service.interface';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable()
export class SurveyRestConnectorService extends RestConnectorService implements EntityConnectorInterface<SurveyInterface> {
  constructor(private readonly _httpClient: HttpClient,
              protected readonly _store: Store<AppStateInterface>,
              private _route: ActivatedRoute) {
    super(_store);
  }

  public loadAll(): Observable<SurveyInterface[]> {
    return of([this.generateMockSurvey()]);
  }

  public loadAllByUserId(userId: number): Observable<SurveyInterface[]> {
    return this._httpClient.get<SurveyInterface[]>(
      `/api/users/${userId}/surveys`,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<SurveyInterface[]>) => {
        return httpResponse.body;
      }),
    );
  }

  public loadOne(id: number): Observable<SurveyInterface> {
    throw new Error('Method not implemented.');
  }

  public loadCurrent(tid: number): Observable<Readonly<SurveyInterface>> {
    const url: string = (tid) ? `current/${tid}` : 'current';
    return this.loadOneByUserId(undefined, url);
  }
  public loadCurrentNew(): Observable<Readonly<SurveyInterface>> {
    const tid: string = this._route.snapshot && this._route.snapshot.queryParamMap.get('taskid');
    const url: string = (tid) ? `new/${tid}` : 'new';
    return this.loadOneByUserId(undefined, url);
  }
  public loadOneByUserId(userId: number, url:string= ''): Observable<Readonly<SurveyInterface>> {
    const userIdFilter: number = (userId) ? userId : this._authenticatedUser$.value.id;
    const dynamicUrl: string = (url) ? url :'current';
    return this._httpClient.get<SurveyInterface>(
      `/api/users/${userIdFilter}/surveys/${dynamicUrl}`,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<SurveyInterface>) => {
        return httpResponse.body;
      }),
    );
  }

  public update(entity: SurveyInterface): Observable<SurveyInterface> {
    const userId: number = this._authenticatedUser$.value.id;
    const tid: string = this._route.snapshot && this._route.snapshot.queryParamMap.get('taskid');
    const url: string = (tid) ? `/${tid}` : '';
    return this._httpClient.put<SurveyInterface>(
      `/api/users/${userId}/surveys/current${url}`,
      entity,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<SurveyInterface>) => {
        let survey: SurveyInterface;
        if (httpResponse.status === 204 && !httpResponse.body) {
          survey = entity;
        } else {
          survey = <SurveyInterface>httpResponse.body;
        }
        return survey;
      }),
    );
  }


  /**
   * Generate a mock Survey object from the actual return values from the survey endpoint.
   */
  public generateMockSurvey(): SurveyInterface {

    /* tslint:disable:max-line-length */
    const json: any = {
      lastCompletedPage: 0,
      id: 2599,
      subject: {
        userId: 425,
        userName: 'aaraujo@huckabee-inc.com',
        firstName: 'Alex',
        lastName: 'Araujo',
        displayName: 'Araujo, Alex - aaraujo@huckabee-inc.com',
        primaryPhone: '(555) ___-____',
        primaryEmail: 'aaraujo@huckabee-inc.com',
        secondaryEmail: 'aaraujo@huckabee-inc.com',
        gender: 2,
        userDisabled: false,
        isAdminUser: false,
        fullDataAccess: true,
        roleId: 8,
        roleLabel: 'default_user',
        profileFilterValues: [
          {
            value: '-1',
            label: '',
            filterId: '4',
            filterLabel: 'Division',
          },
          {
            value: '-1',
            label: '',
            filterId: '5',
            filterLabel: 'Location',
          },
          {
            value: '-1',
            label: '',
            filterId: '1',
            filterLabel: 'City',
          },
          {
            value: '23',
            label: 'Huckabee',
            filterId: '2',
            filterLabel: 'Company',
          },
          {
            value: '-1',
            label: '',
            filterId: '3',
            filterLabel: 'Ergo Consultant',
          },
        ],
        customFieldValues: [
          {
            id: 'supervisor_name',
            label: 'Supervisors Name',
            value: '',
          },
          {
            id: 'supervisor_email',
            label: 'Supervisors Email',
            value: '',
          },
          {
            id: 'supervisor_phone',
            label: 'Supervisors Phone Number',
            value: '',
          },
          {
            id: 'workers_name',
            label: 'EH&S/Workers Comp Contact Name',
            value: '',
          },
          {
            id: 'workers_email',
            label: 'Job Description',
            value: '',
          },
          {
            id: 'workers_phone',
            label: 'EH&S/Workers Comp Contact Phone Number',
            value: '',
          },
        ],
      },
      admin: {
        userId: 425,
        userName: 'aaraujo@huckabee-inc.com',
        firstName: 'Alex',
        lastName: 'Araujo',
        displayName: 'Araujo, Alex - aaraujo@huckabee-inc.com',
        primaryPhone: '(555) ___-____',
        primaryEmail: 'aaraujo@huckabee-inc.com',
        secondaryEmail: 'aaraujo@huckabee-inc.com',
        gender: 2,
        userDisabled: false,
        isAdminUser: false,
        fullDataAccess: true,
        roleId: 8,
        roleLabel: 'default_user',
        profileFilterValues: [
          {
            value: '-1',
            label: '',
            filterId: '4',
            filterLabel: 'Division',
          },
          {
            value: '-1',
            label: '',
            filterId: '5',
            filterLabel: 'Location',
          },
          {
            value: '-1',
            label: '',
            filterId: '1',
            filterLabel: 'City',
          },
          {
            value: '23',
            label: 'Huckabee',
            filterId: '2',
            filterLabel: 'Company',
          },
          {
            value: '-1',
            label: '',
            filterId: '3',
            filterLabel: 'Ergo Consultant',
          },
        ],
        customFieldValues: [
          {
            id: 'supervisor_name',
            label: 'Supervisors Name',
            value: '',
          },
          {
            id: 'supervisor_email',
            label: 'Supervisors Email',
            value: '',
          },
          {
            id: 'supervisor_phone',
            label: 'Supervisors Phone Number',
            value: '',
          },
          {
            id: 'workers_name',
            label: 'EH&S/Workers Comp Contact Name',
            value: '',
          },
          {
            id: 'workers_email',
            label: 'Job Description',
            value: '',
          },
          {
            id: 'workers_phone',
            label: 'EH&S/Workers Comp Contact Phone Number',
            value: '',
          },
        ],
      },
      date: '2018-06-01T00:00:00',
      isComplete: true,
      analysis: {
        riskScore: 1053,
        overallDiscomfort: 'Constant',
      },
      unablesCount: 7,
      pages: [
        {
          title: 'Office Worker Survey',
          subTitle: '',
          questions: [
            {
              id: 1,
              label: 'How many hours per day do you spend at your computer?',
              group: 'PP',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: '0-2',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 4,
                  label: '2-4',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 5,
                  label: '6-8',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: '4-6',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 7,
                  label: '8+',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 5,
              label: 'How long can you remain seated before you become uncomfortable?',
              group: 'PP',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 28,
                  label: 'up to 1 hour',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 29,
                  label: '2 hours',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 30,
                  label: '3 hours',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 31,
                  label: '4 hours',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 32,
                  label: '5+ hours',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 4,
              label: 'How many hours per day do you spend on the phone?',
              group: 'PP',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 23,
                  label: '0-1',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 24,
                  label: '1-2',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 25,
                  label: '2-3',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 26,
                  label: '3+',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 2,
              label: 'Do you wear corrective eye wear?',
              group: 'PP',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestionTriggers: [
                6,
                9,
                33,
                34,
                54,
                55,
              ],
              childQuestions: [
                {
                  id: 7,
                  label: 'When do you wear your corrective eyewear?',
                  group: 'PP',
                  groupLabel: 'Office Worker Survey',
                  isMultipleChoice: false,
                  childQuestions: [

                  ],
                  answers: [
                    {
                      id: 38,
                      label: 'Always',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 40,
                      label: 'At work',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 42,
                      label: 'At the computer',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 44,
                      label: 'When driving',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 46,
                      label: 'Other',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 48,
                      label: 'None',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                  ],
                },
              ],
              answers: [
                {
                  id: 2,
                  label: 'No',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 6,
                  label: 'Standard',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 9,
                  label: 'Bifocal',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 33,
                  label: 'Trifocal',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 34,
                  label: 'Progressive',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 54,
                  label: 'Computer Glasses',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 55,
                  label: 'Contact Lenses',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 3,
              label: 'Do you have any physical concerns?',
              group: 'PP',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 10,
                  label: 'Neurological',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 11,
                  label: 'Muscular',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 12,
                  label: 'Skeletal',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 13,
                  label: 'Circulatory',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 27,
                  label: 'Impaired Vision',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 36,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 9,
              label: 'Which is your dominant hand?',
              group: 'PP',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 50,
                  label: 'Right hand',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 52,
                  label: 'Left hand',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 1,
              label: 'How do you find the temperature in your environment?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 2,
                  label: 'Always too hot or too cool',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 5,
                  label: 'Good',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 17,
                  label: 'Sometimes too hot or too cool',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 2,
              label: 'How is the lighting in your environment?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 6,
                  label: 'Always too bright or too dim',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 8,
                  label: 'Good',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 15,
                  label: 'Sometimes too bright or too dim',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 3,
              label: 'Are you able to adjust your monitor and keyboard so you can work in a seated or standing position?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestionTriggers: [
                10,
              ],
              childQuestions: [
                {
                  id: 4,
                  label: 'How many times per day do you move from a seated position to a standing position?',
                  group: 'WE',
                  groupLabel: 'Office Worker Survey',
                  isMultipleChoice: false,
                  childQuestions: [

                  ],
                  answers: [
                    {
                      id: 12,
                      label: '0',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 13,
                      label: '1',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 14,
                      label: '2',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 19,
                      label: '3',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 20,
                      label: '4',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 21,
                      label: '5',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 22,
                      label: '6',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 23,
                      label: '7',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 24,
                      label: '8+',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                  ],
                },
              ],
              answers: [
                {
                  id: 9,
                  label: 'No',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 10,
                  label: 'Yes',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 6,
              label: 'Do you have any broken or non-functioning equipment at your workstation?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestionTriggers: [
                28,
              ],
              childQuestions: [
                {
                  id: 8,
                  label: 'Which equipment is not functioning?',
                  group: 'WE',
                  groupLabel: 'Office Worker Survey',
                  isMultipleChoice: false,
                  childQuestions: [

                  ],
                  answers: [
                    {
                      id: 30,
                      label: 'Keyboard',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 32,
                      label: 'Mouse',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 34,
                      label: 'Chair',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 36,
                      label: 'Desk',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 38,
                      label: 'Computer',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 40,
                      label: 'Monitor',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 42,
                      label: 'Headset',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 44,
                      label: 'Document Holder',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 46,
                      label: 'Keyboard Tray',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 48,
                      label: 'Monitor Arm',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 50,
                      label: 'Other',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                    {
                      id: 51,
                      label: 'None',
                      isIdeal: false,
                      hasTextField: false,
                      isSelected: false,
                    },
                  ],
                },
              ],
              answers: [
                {
                  id: 26,
                  label: 'No',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 28,
                  label: 'Yes',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 12,
              label: 'Which type of keyboard do you have?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 53,
                  label: 'Standard Keyboard',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 55,
                  label: 'Alternate/Ergonomic Keyboard',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 57,
                  label: 'Other',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 14,
              label: 'Do you have a keyboard palm/wrist rest?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 61,
                  label: 'No',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 59,
                  label: 'Yes',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 16,
              label: 'Which type of mouse do you have?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 63,
                  label: 'Standard Mouse',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 65,
                  label: 'Specialty Mouse',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 66,
                  label: 'Trackball',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 67,
                  label: 'Other',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 18,
              label: 'Do you have a mouse palm/wrist rest?',
              group: 'WE',
              groupLabel: 'Office Worker Survey',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 71,
                  label: 'No',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 69,
                  label: 'Yes',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
          ],
        },
        {
          title: 'Office Worker Survey',
          subTitle: '',
          questions: [
            {
              id: 1,
              label: 'Neck',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 2,
              label: 'Upper Back',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 4,
              label: 'Left Elbow',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 3,
              label: 'Right Elbow',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 5,
              label: 'Lower Back',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 7,
              label: 'Left Upper Leg',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 6,
              label: 'Right Upper Leg',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 9,
              label: 'Left Lower Leg',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 8,
              label: 'Right Lower Leg',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 10,
              label: 'Head',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 11,
              label: 'Eyes/Blurred Vision',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 12,
              label: 'Right Shoulder',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 13,
              label: 'Left Shoulder',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 21,
              label: 'Left Foot',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 20,
              label: 'Right Foot',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 19,
              label: 'Left Knee',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 18,
              label: 'Right Knee',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 17,
              label: 'Left Hand/Fingers',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 16,
              label: 'Right Hand/Fingers',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 24,
              label: 'Left Hip',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 25,
              label: 'Right Hip',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 15,
              label: 'Left Wrist',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 14,
              label: 'Right Wrist',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 22,
              label: 'Right Forearm',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 23,
              label: 'Left Forearm',
              group: 'DC',
              groupLabel: 'Discomfort',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'None',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 2,
                  label: 'Occasional',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 3,
                  label: 'Frequent',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 4,
                  label: 'Constant',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
          ],
        },
        {
          title: 'Equipment Evaluation',
          subTitle: '',
          questions: [
            {
              id: 1,
              label: 'Monitor Type',
              group: 'ECMonitorType',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 9,
                  label: 'Single Monitor',
                  imagePath: '/Content/Images/equipment/LCDSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 15,
                  label: 'Multiple Monitors',
                  imagePath: '/Content/Images/equipment/DubLCDSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 1,
                  label: 'Laptop',
                  imagePath: '/Content/Images/equipment/LaptopSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 14,
                  label: 'Laptop and Monitor',
                  imagePath: '/Content/Images/equipment/LaptopLCDSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 2,
              label: 'Keyboard Location',
              group: 'ECKeyboardPlacement',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 3,
                  label: 'Keyboard on desk',
                  imagePath: '/Content/Images/equipment/KeyboardOnDeskSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 5,
                  label: 'Keyboard on tray',
                  imagePath: '/Content/Images/equipment/KeyboardOnMechSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 3,
              label: 'Mouse Location',
              group: 'ECMousePlacement',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 4,
                  label: 'Mouse on desk',
                  imagePath: '/Content/Images/equipment/MouseOnDeskSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 17,
                  label: 'Mouse on tray',
                  imagePath: '/Content/Images/equipment/MouseOnMechSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 4,
              label: 'Reported Accessories',
              group: 'ECAccessories',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 11,
                  label: 'Monitor Arm',
                  imagePath: '/Content/Images/equipment/ArmSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 7,
                  label: 'Footrest',
                  imagePath: '/Content/Images/equipment/FootRestSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 18,
                  label: 'Headset',
                  imagePath: '/Content/Images/equipment/HeadsetSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 6,
                  label: 'Document Holder',
                  imagePath: '/Content/Images/equipment/DocHolderSelected.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
          ],
        },
        {
          title: 'Posture Evaluation',
          subTitle: 'Click on the picture that most closely represents your normal body posture at your workstation.',
          questions: [
            {
              id: 40,
              label: 'Position of feet',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 141,
                  label: 'Feet are flat on the floor or flat on a footrest',
                  imagePath: 'On_FeetOnTheFloor.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 137,
                  label: 'Feet are off the floor',
                  imagePath: 'On_FeetOffTheFloor.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 38,
              label: 'Position of knees',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 140,
                  label: 'Knees are even with the hips',
                  imagePath: 'On_KneesLevelWithHips.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 142,
                  label: 'Knees are above the hips',
                  imagePath: 'On_KneesAboveTheHips.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 144,
                  label: 'Knees are below the hips',
                  imagePath: 'On_KneesBelowTheHips.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 39,
              label: 'Position of upper body',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 147,
                  label: 'Upright and straight',
                  imagePath: 'On_TorsoUpright.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 145,
                  label: 'Leaning back',
                  imagePath: 'On_TorsoBackwards.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 149,
                  label: 'Leaning forward',
                  imagePath: 'On_TorsoForward.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 41,
              label: 'Position of head',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 151,
                  label: 'Looking straight ahead or slightly downwards',
                  imagePath: 'On_HeadErect.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 150,
                  label: 'Looking Down',
                  imagePath: 'On_HeadDownward.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 152,
                  label: 'Looking up',
                  imagePath: 'On_HeadUpward.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 42,
              label: 'Position of elbow',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 155,
                  label: 'At side',
                  imagePath: 'On_ElbowMiddle.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 154,
                  label: 'Forward of your body',
                  imagePath: 'On_ElbowMoreExtended.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 153,
                  label: 'Behind your body',
                  imagePath: 'On_ElbowSlightlyExtended.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 43,
              label: 'Position of forearm',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 157,
                  label: 'Level',
                  imagePath: 'On_ForearmLevel.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 156,
                  label: 'Angled down',
                  imagePath: 'On_ForearmDownward.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 161,
                  label: 'Angled up',
                  imagePath: 'On_ForearmUpward.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 45,
              label: 'Wrists when keying',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 138,
                  label: 'Level',
                  imagePath: 'On_WristKeyingNeutral.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 158,
                  label: 'Bent upward when keying',
                  imagePath: 'On_WristKeyingExtended.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 148,
                  label: 'Bent downward when keying',
                  imagePath: 'On_WristKeyingFlexed.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 71,
              label: 'Wrist direction on the keyboard',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 262,
                  label: 'Straight',
                  imagePath: 'On_WristKeyingNeutral2.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 261,
                  label: 'Bent inward when keying',
                  imagePath: 'On_WristKeyingFlexed2.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 263,
                  label: 'Bent outward when keying',
                  imagePath: 'On_WristKeyingExtended2.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 44,
              label: 'Wrist when mousing',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 160,
                  label: 'Straight',
                  imagePath: 'On_WristMousingNeutral.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 159,
                  label: 'Bent outward when mousing',
                  imagePath: 'On_WristMousingExtended.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 180,
                  label: 'Bent inward when mousing',
                  imagePath: 'On_WristMousingFlexed.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 70,
              label: 'Wrist bend when mousing',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 259,
                  label: 'Level',
                  imagePath: 'On_WristMousingNeutral2.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 258,
                  label: 'Bent upward when mousing',
                  imagePath: 'On_WristMousingExtended2.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 260,
                  label: 'Bent downward when mousing',
                  imagePath: 'On_WristMousingFlexed2.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 50,
              label: 'Position of Chair Seat',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 244,
                  label: 'Space between seat pan and back of knees',
                  imagePath: 'On_ChairSeatDepthGap.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 247,
                  label: 'No space between back of knees and seat pan',
                  imagePath: 'On_ChairSeatDepthNoGap.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 51,
              label: 'Position of Chair Back',
              group: 'PS',
              groupLabel: 'Posture Self-Assessment Results',
              isMultipleChoice: false,
              childQuestions: [

              ],
              answers: [
                {
                  id: 250,
                  label: 'Back supported by chair back',
                  imagePath: 'On_ChairBackDepthNoGap.png',
                  isIdeal: true,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 248,
                  label: 'Back not supported by chair back',
                  imagePath: 'On_ChairBackDepthGap.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
          ],
        },
        {
          title: 'Photo Upload',
          subTitle: '',
          questions: [

          ],
        },
        {
          title: 'Comfort Zone Analysis',
          subTitle: '',
          questions: [
            {
              id: 15,
              label: 'Adjusting your chair',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'chair.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I understand how and I am able to adjust my chair',
                  imagePath: 'chair.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 0,
                  label: 'I do not understand how or I am not able to adjust my chair',
                  imagePath: 'chair.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 1,
              label: 'Adjusting your chair height',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'off_feetonthefloor.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can sit with my feet flat on the floor',
                  imagePath: 'off_feetonthefloor.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 0,
                  label: 'I am unable to sit with my feet flat on the floor',
                  imagePath: 'off_feetonthefloor.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 2,
              label: 'Adjusting your chair seat pan',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'fist.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can adjust my chair so my fist can fit between the front of the chair and my knee',
                  imagePath: 'fist.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 0,
                  label: 'I am not able to adjust my seat pan',
                  imagePath: 'fist.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 3,
              label: 'Adjusting your chair seat pan angle',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'off_kneeslevelwithhips.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I am able to put most of my weight on the back of the seat with my hips above my knees',
                  imagePath: 'off_kneeslevelwithhips.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 0,
                  label: 'I am not able to put most of my weight on the back of the seat with my hips above my knees',
                  imagePath: 'off_kneeslevelwithhips.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 5,
              label: 'Adjusting your head and neck position',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'off_headerect.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I am able to work with my upper body and head erect looking straight forward',
                  imagePath: 'off_headerect.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 0,
                  label: 'I am not able to work with my upper body and head erect looking straight forward',
                  imagePath: 'off_headerect.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 6,
              label: 'Adjusting your chair back',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'off_chairbackdepthnogap.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can adjust my chair back to support my back and not interfere with my shoulders',
                  imagePath: 'off_chairbackdepthnogap.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 0,
                  label: 'I cannot adjust my chair back to support my back and not interfere with my shoulders',
                  imagePath: 'off_chairbackdepthnogap.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 7,
              label: 'Moving in your workspace',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'movement.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I am able to move freely in my chair with adequate clearance under my desk',
                  imagePath: 'movement.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 0,
                  label: 'I am not able to move freely in my chair',
                  imagePath: 'movement.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 9,
              label: 'Adjusting your monitor',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'monitor.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can position my monitor(s), keyboard and mouse so that they are directly in front of me at a comfortable viewing distance, height, and angle.',
                  imagePath: 'monitor.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 0,
                  label: 'I am not able to position my monitor(s), keyboard and mouse so that they are comfortable',
                  imagePath: 'monitor.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 14,
              label: 'Adjusting your paperwork',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'paperwork.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can position my paperwork so it can be viewed without turning my head to the side or looking down',
                  imagePath: 'paperwork.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 0,
                  label: 'I am unable to view my paperwork without turning my head to the side or looking down',
                  imagePath: 'paperwork.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 10,
              label: 'Adjusting your keyboard',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'keyboarding.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can position my keyboard so that my upper arms are at my side, my forearms below horizontal, and my wrists are in a neutral posture when keying',
                  imagePath: 'keyboarding.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 0,
                  label: 'I am not able to move my keyboard to a neutral position while keying',
                  imagePath: 'keyboarding.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
            {
              id: 13,
              label: 'Adjusting your mouse position',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'mouse.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can position my mouse so that my upper arms are at my side, my forearms below horizontal, and my wrists are in a neutral posture when mousing',
                  imagePath: 'mouse.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 0,
                  label: 'I am not able to move my mouse to a neutral position while mousing',
                  imagePath: 'mouse.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 11,
              label: 'Relaxing your shoulders',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'shoulders.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I can use my keyboard and mouse while my shoulders are relaxed',
                  imagePath: 'shoulders.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
                {
                  id: 0,
                  label: 'I am not able to use my keyboard and mouse while my shoulders are relaxed.',
                  imagePath: 'shoulders.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
              ],
            },
            {
              id: 12,
              label: 'Workspace comfort',
              group: 'UA',
              isMultipleChoice: false,
              imagePath: 'iamcomfortable.png',
              childQuestions: [

              ],
              answers: [
                {
                  id: 1,
                  label: 'I am comfortable in my workspace',
                  imagePath: 'iamcomfortable.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: true,
                },
                {
                  id: 0,
                  label: 'I am uncomfortable in my workspace',
                  imagePath: 'iamcomfortable.png',
                  isIdeal: false,
                  hasTextField: false,
                  isSelected: false,
                },
              ],
            },
          ],
        },
      ],
    };
    /* tslint:enable:max-line-length */

    json.date = new Date(json.date);
    return new Survey(json);
  }
}
